var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPanorays(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "panorays__Integration=Panorays, Size=24",
    className: "panorays__Integration=Panorays, panorays__Size=24",
    clipPath: "url(#panorays__clip0_23783_290857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "panorays__Frame 427321643",
    className: "panorays__Frame panorays__427321643"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "panorays__Clip path group",
    className: "panorays__Clip panorays__path panorays__group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "panorays__Group",
    className: "panorays__Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "panorays__Vector",
    fill: "#FFA100",
    d: "m16.436 6.343-7.803 4.714a.674.674 0 0 1-.698-1.153l.073-.036 8.307-3.723a.117.117 0 0 1 .15.057.117.117 0 0 1-.045.141",
    className: "panorays__Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "panorays__Vector_2",
    fill: "#FFB500",
    d: "M14.915 5.303 8.56 8.323a.677.677 0 0 1-.593-1.217l.101-.036 6.755-1.976a.113.113 0 0 1 .137.076.109.109 0 0 1-.057.133",
    className: "panorays__Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "panorays__Vector_3",
    fill: "#FF8200",
    d: "m15.658 8.597-6.969 5.267a.674.674 0 1 1-.806-1.073l.084-.048 7.582-4.336a.113.113 0 1 1 .125.19",
    className: "panorays__Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "panorays__Vector_4",
    fill: "#FF6E00",
    d: "M12.403 12.98 8.75 16.752a.678.678 0 0 1-.972-.944.775.775 0 0 1 .113-.088l4.375-2.912a.113.113 0 0 1 .141.174",
    className: "panorays__Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "panorays__Vector_5",
    fill: "#FF5900",
    d: "m10.984 16.701-2.186 3.025a.682.682 0 1 1-.956-.952l2.98-2.222a.11.11 0 0 1 .158.02.117.117 0 0 1 0 .137",
    className: "panorays__Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "panorays__Vector_6",
    fill: "#FFD117",
    d: "M12.847 4.215 8.479 5.852a.677.677 0 1 1-.475-1.266.556.556 0 0 1 .157-.037l4.646-.552a.113.113 0 0 1 .124.1.117.117 0 0 1-.072.118",
    className: "panorays__Vector"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "panorays__clip0_23783_290857",
    className: "panorays__clip0_23783"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanorays);
export default __webpack_public_path__ + "static/media/Panorays.aa405a6b2475e3445d7016b4bbc9d9de.svg";
export { ForwardRef as ReactComponent };